module.exports = __webpack_public_path__ + "assets/img/balance.7f0c7d7d.png";